module.exports = __webpack_public_path__ + "img/icon3.e8f7e723.png";